var render, staticRenderFns
import script from "./Historicalworkorder.vue?vue&type=script&lang=js&"
export * from "./Historicalworkorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4fe6b2",
  null
  
)

export default component.exports